import { takeUntil } from 'rxjs';
import { createElement } from 'src/app/core/helpers/dom';
import { onElementDestroy } from 'src/app/core/helpers/on-element-destroy';
import { DropdownService } from 'src/app/project/components/dropdown/dropdown-service/dropdown.service';
import { getGroupSizesChange$ } from 'src/app/project/modules/points/points-group-sizes/group-sizes.store';
import { findMatchingPartialCount } from 'src/app/project/modules/points/points-group-sizes/match-partial-count';
import { TTableItem } from '../../custom-table/table.model';
import { GET_TABLE } from '../../table.ui.store';
import { createOptionsElement } from './create-header-row/utils/create-options-element';

const COUNT_PLACEHOLDER = '...';

function computeCount(item: TTableItem): number | null {
  const matchingPartialCount = item.groupBy ? findMatchingPartialCount(item.groupBy) : undefined;

  if (matchingPartialCount) {
    return matchingPartialCount.count;
  }

  return null;
}

function formatCountAsString(item: TTableItem): string {
  const count = computeCount(item);
  return count === null ? COUNT_PLACEHOLDER : String(count);
}

export function createPointCountElement(
  _index: number,
  dropdownService: DropdownService,
): HTMLElement {
  const table = GET_TABLE();
  const item = table.items[_index];

  const countElement = createElement('span', {
    attrs: {
      class: 'table__pointCount__count',
    },
    children: [formatCountAsString(item)],
  });

  const container = createElement<HTMLElement>('div', {
    attrs: {
      class: 'table__pointCount',
    },
    children: [countElement, createOptionsElement(_index, dropdownService)],
  });

  getGroupSizesChange$()
    .pipe(takeUntil(onElementDestroy(container)))
    .subscribe(() => {
      countElement.textContent = formatCountAsString(item);
    });

  return container;
}
